import React from "react";

import MainLayout from '../layouts/MainLayout'
import UserProfileCard from '../components/UserProfileCard'
import OrganisationCard from '../components/OrganisationCard'
import TeamCard from '../components/TeamCard'

const UserProfile = () => {
  return (
    <MainLayout>
      <h1 className="text-4xl font-semibold text-gray-800 dark:text-white">Mon compte</h1>
      <h2 className=" text-gray-400">Récapitulatif de votre compte</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 my-6">
        <div className="col-span-2">
          <UserProfileCard />
        </div>
        <div>
          <OrganisationCard/>
          <TeamCard/>
        </div>
      </div>
    </MainLayout>
  );
}

export default UserProfile
